let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("acVY4")).then(() => parcelRequire('4p9lZ'));